export default __webpack_public_path__ + "static/media/disappearing-house.63cb117f.gif";